<template>
  <div class="control-weather-crosshair">
    <x-icon
      icon="weather/crosshair-outline"
      width="72"
      height="72"
      data-test="weather-crosshair"
    />
    <x-icon
      :icon="weatherIcon"
      width="18"
      height="18"
      class="weather-icon"
      data-test="weather-crosshair-icon"
    />
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import xIcon from '@/components/shared/x-icon'

import { getCurrentConditions } from '@/services/weather-service'
import { camera } from '@/services/map-service'

export default {
  name: 'ControlWeatherCrosshair',
  components: {
    xIcon,
  },
  computed: {
    // eslint-disable-next-line vue/no-unused-properties
    camera,
    conditions: () => getCurrentConditions(),
    weatherIcon() {
      if (this.conditions) {
        return `weather/aeris/${this.conditions[0]?.iconName?.toLowerCase()}`
      }

      return 'weather/disabled-weather'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.control-weather-crosshair {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .weather-icon {
    position: absolute;
    color: var(--ys-color-text-constant-primary);
  }
}

@media print {
  .control-weather-crosshair {
    display: none;
  }
}
</style>
